import { Routes } from '@angular/router';
import { ListComponent } from './pages/list/list.component';
import { DetailComponent } from './pages/detail/detail.component';
import { EventResolver } from './resolvers/event.resolver';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'events/todos',
    pathMatch: 'full',
    data: {
      title: 'TIX - Entradas para Eventos',
      description: 'Compra entradas para los mejores eventos en República Dominicana',
      ogTitle: 'TIX - Entradas para Eventos',
      ogDescription: 'Compra entradas para los mejores eventos en República Dominicana',
      ogImage: 'https://tix-shared.s3.us-east-1.amazonaws.com/tix-default-bg.jpeg',
      ogType: 'website'
    }
  },
  {
    path: 'events/:category_hash',
    component: ListComponent,
    data: {
      title: 'Eventos - TIX',
      description: 'Descubre los próximos eventos en República Dominicana',
      ogTitle: 'Próximos Eventos - TIX',
      ogDescription: 'Descubre los próximos eventos en República Dominicana',
      ogImage: 'https://tix-shared.s3.us-east-1.amazonaws.com/tix-default-bg.jpeg',
      ogType: 'website'
    }
  },
  {
    path: 'event/:event_slug',
    component: DetailComponent,
    resolve: {
      event: EventResolver
    },
    data: {
      // These will be overridden by the resolver data
      title: 'Evento - TIX',
      description: 'Información del evento',
      ogTitle: 'Evento - TIX',
      ogDescription: 'Información del evento',
      ogImage: 'https://tix-shared.s3.us-east-1.amazonaws.com/tix-default-bg.jpeg',
      ogType: 'website',
      // Tell the server to wait for the resolver
      waitForResolver: true
    },
    runGuardsAndResolvers: 'always' as const
  },
];
